import React from 'react';
import clsx from 'clsx';
import { TitleImage } from "../AboutPageGeneralComp";

/**
 *  This component renders the steps of first section of example 'design a page' in 
 *  markdown body.  
 */
const DesignPageSection1 = ({elSubRefs}) => (
    <>
        <EditNavbar elSubRefs={elSubRefs} />
        <EditBreadCrumb elSubRefs={elSubRefs} />
        <InsertColumn elSubRefs={elSubRefs} />
        <InsertListGroup elSubRefs={elSubRefs} />
        <EditListGroup elSubRefs={elSubRefs} />
    </>
)

// This component renders edit navbar step
const EditNavbar = ({elSubRefs}) => (
    <div id="Group8Sub1" ref={elSubRefs[0]} className={clsx("subgroup")}>
        <h4 id="Group8Sub1">Insert/Edit a Navbar</h4><br />
        <TitleImage
            title='Drag and Drop a Navbar inside your page.'
            srcImg='/images/AboutPageMarkdownImg/7.jpg'
        />
    </div>
)

//  This component renders edit breadcrum step
const EditBreadCrumb = ({elSubRefs}) => (
    <div id="Group8Sub2" ref ={elSubRefs[1]} className={clsx("subgroup")}>
        <h4 id="Group8Sub2">Insert/Edit a Breadcrumb</h4><br />
        <TitleImage 
            title='Drag and Drop a Breadcrumb inside your page.'
            srcImg= '/images/AboutPageMarkdownImg/8.jpg'
        />
    </div>
)

//  This component renders insert column step
const InsertColumn = ({elSubRefs}) => (
    <div id="Group8Sub3" ref ={elSubRefs[2]} className={clsx("subgroup")}>
        <h4 id="Group8Sub3">Insert Column (e.g. 3/7)</h4><br />
        <TitleImage 
            title='Drag and Drop a "2 Columns 3/7" block.'
            srcImg='/images/AboutPageMarkdownImg/9.jpg'
        />
    </div>
)


//  This component renders insert list group step
const InsertListGroup = ({elSubRefs}) => (
    <div id="Group8Sub4" ref ={elSubRefs[3]} className={clsx("subgroup")}>
        <h4 id="Group8Sub4">Insert a List Group</h4><br />
        <TitleImage 
            title='Drag and Drop a List Group block.'
            srcImg= '/images/AboutPageMarkdownImg/10.jpg' 
        />
    </div>  
)


//  This component renders edit list group step
const EditListGroup = ({elSubRefs}) => (
    <div id="Group8Sub5" ref ={elSubRefs[4]} className={clsx("subgroup")}>
        <h4 id="Group8Sub5">Edit the List Group.</h4>
        <TitleImage
            title='Edit the content of the List Group by double clicking on its content.'
            srcImg= '/images/AboutPageMarkdownImg/11.jpg'
        />
    </div>
)

export default DesignPageSection1;